import type { TourDefinition } from '../types';

export const FIRST_CRITERIA_GENERATED_TOUR_ID = 'first-criteria-generated';

export const firstCriteriaGeneratedTour: TourDefinition = {
  id: FIRST_CRITERIA_GENERATED_TOUR_ID,
  steps: [
    {
      kind: 'modal',
      eyebrow: 'YOUR CRITERIA IS READY',
      title: 'The bar every candidate gets scored against',
      body: "Beacon generated this hiring thesis and criteria from your guidance plus BreakLine's decade of context and methodology across the industry. Take a couple of minutes to refine and edit this criteria so it matches your intent.",
      primaryLabel: 'Show me around',
      skipLabel: 'Not now',
    },
    {
      target: 'criteria-thesis',
      placement: 'bottom',
      scrollOffset: 110,
      title: 'Define what right looks like',
      body: "This top section defines what effect you're trying to achieve. It defines the need and clarifies why you're hiring this person and what you're counting on them to accomplish.",
    },
    {
      target: 'criteria-position',
      placement: 'right',
      scrollOffset: 110,
      title: 'The bar, criterion by criterion',
      body: 'The first step in solving any problem is recognizing and defining the problem. Job descriptions are vague and often wrong. Our methodology drives a decomposition of the hiring thesis into skills, abilities, and values that bring clarity and rigor to an interview plan and hiring decision.',
    },
    {
      target: 'criteria-actions',
      placement: 'bottom',
      title: 'Save & publish',
      body: "Your edits are now saved as a draft. When you're ready to solidify this version of your hiring thesis and criteria, click Publish and Beacon will score every candidate in this job's Talent Pool. If you don't have a Talent Pool yet, the Published version will be ready and waiting as soon as candidates are uploaded.",
      primaryLabel: 'Finish',
    },
  ],
};
